import { render, staticRenderFns } from "./ComponentEditingHeader.vue?vue&type=template&id=4f912b30&"
import script from "./ComponentEditingHeader.vue?vue&type=script&lang=js&"
export * from "./ComponentEditingHeader.vue?vue&type=script&lang=js&"
import style0 from "./ComponentEditingHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports